import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex-direction: row;
  margin-top: ${RFValue(12)}px;
  justify-content: flex-end;
`;

export const SendCodeButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
  padding-bottom: ${RFValue(2)}px;
`;

export const SendCode = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;
`;
